export default __webpack_public_path__ + "static/media/1304.9c774a94.png";